import { createSelector } from 'helpers/reselect'

const getRelatedArticlesSelector = ({ relatedArticles } = {}) => relatedArticles

export const getRelatedArticles = createSelector(
  [getRelatedArticlesSelector],
  ({
    articles = []
  } = {}) => articles
)
